import React from 'react';
import { bespokeRightConfig } from '../config/bespokeBackgrounds'; 
import { getBespokeConfig } from '../utils/ui.utils';

export const BespokeRight = ({ brand, grs, treatment, data_email, data_math, data }) => {
  const resolutionData = data || { grs, normalizedTreatment: treatment, email: data_email, math: data_math };
  const config = getBespokeConfig(brand, bespokeRightConfig, resolutionData);

  if (!config) {
    return null;
  }

  const finalStyle = {
    backgroundImage: config.bgSrc,
    opacity: config.opacity !== undefined ? config.opacity : undefined,
    backgroundPosition: config.backgroundPosition !== undefined ? config.backgroundPosition : undefined
  };

  return (
    <div className="il lower-bg" style={finalStyle}></div>
  );
};